import { Logger } from "../../logger";
import { Injectable, Optional } from "@angular/core";
import { TagGroup } from "../../../domain/tag-group";
import { Tag } from "../../../domain/tag";

const GeneralTagGroupId = 3;

function toTagGroup(tagGroup: any): TagGroup {
  return new TagGroup(
    tagGroup.IsGeneral,
    tagGroup.TagGroupId,
    tagGroup.TagGroupName,
    tagGroup.Tags.map((tag) => new Tag(tag.IsGeneral, tag.TagId, tag.TagName)),
  );
}

@Injectable()
export class TagMapper {
  constructor(@Optional() private logger: Logger) {}

  mapGetAllTagsResponse(response: any): Promise<TagGroup[]> {
    let tagGroups = !!response && response.length > 0 ? response : [];
    return Promise.resolve(tagGroups.map((x) => toTagGroup(x)));
  }

  mapCreateGeneralTagRequest(tagName) {
    return {
      TagName: tagName,
      TagGroupId: GeneralTagGroupId,
    };
  }

  mapCreateGeneralTagResponse(tagResponse) {
    return new Tag(
      tagResponse.IsGeneral,
      tagResponse.TagId,
      tagResponse.TagName,
    );
  }
}
